import React, { useState } from "react";
import { FaGift, FaExternalLinkAlt, FaCompass, FaStore, FaArrowRight } from "react-icons/fa";
import ExternalSiteTransitionModal from "./ExternalSiteTransitionModal";
import { buildForfeoComUrl } from "../lib/crossUniverseLinks";

type Props = {
  context?: "home" | "dashboard" | "combo" | "carte_cadeau" | "footer";
  compact?: boolean;
};

export default function CrossUniverseBridgePanel({ context = "home", compact = false }: Props) {
  const [targetUrl, setTargetUrl] = useState<string | null>(null);

  const openForfeoCom = (path: string, target: string) => {
    setTargetUrl(buildForfeoComUrl(path, { source: context, target }));
  };

  return (
    <section className={`rounded-[2rem] border border-blue-100 bg-white shadow-xl shadow-blue-950/5 ${compact ? "p-5" : "p-7"}`}>
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-blue-50 px-3 py-2 text-xs font-black uppercase tracking-[0.22em] text-blue-700">
            <FaCompass /> Écosystème Forfeo
          </div>
          <h3 className="text-2xl font-black tracking-tight text-slate-950">
            Explorez ici. Achetez sur Forfeo.com.
          </h3>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600">
            Forfeo Explore vous aide à découvrir les expériences, régions, Last Call et Combos.
            Forfeo.com gère les achats officiels, les cartes et les paiements sécurisés.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 lg:min-w-[440px]">
          <button
            onClick={() => openForfeoCom("/carte-cadeau", "carte_acces_privilege")}
            className="group rounded-2xl border border-slate-200 bg-gradient-to-br from-white to-blue-50 p-4 text-left transition hover:-translate-y-0.5 hover:shadow-lg"
          >
            <FaGift className="mb-3 text-2xl text-blue-600" />
            <div className="font-black text-slate-950">Carte Accès Privilège</div>
            <div className="mt-1 text-xs leading-5 text-slate-500">Acheter ou offrir une carte Forfeo.</div>
            <div className="mt-3 flex items-center gap-2 text-xs font-black text-blue-700">
              Continuer <FaArrowRight />
            </div>
          </button>

          <button
            onClick={() => openForfeoCom("/boutique", "boutique")}
            className="group rounded-2xl border border-slate-200 bg-gradient-to-br from-white to-indigo-50 p-4 text-left transition hover:-translate-y-0.5 hover:shadow-lg"
          >
            <FaStore className="mb-3 text-2xl text-indigo-600" />
            <div className="font-black text-slate-950">Boutique Forfeo</div>
            <div className="mt-1 text-xs leading-5 text-slate-500">Finaliser un achat ou consulter les offres.</div>
            <div className="mt-3 flex items-center gap-2 text-xs font-black text-indigo-700">
              Ouvrir <FaExternalLinkAlt />
            </div>
          </button>
        </div>
      </div>

      <ExternalSiteTransitionModal
        open={Boolean(targetUrl)}
        href={targetUrl || ""}
        onClose={() => setTargetUrl(null)}
        source={context}
        target="checkout"
      />
    </section>
  );
}
